"use strict";

import angular from "angular";

import template from "./help-item-alerts.component.html";
import "./themes/help-item-alerts.component.scss";
import "./themes/help-item-alerts-dark.component.scss";

class HelpItemAlertsComponent {
    constructor() {}

    $onInit() {}

    $onDestroy() {}

    $onChanges(changes) {}
}

HelpItemAlertsComponent.$inject = [];

const name = "helpItemAlertsComponent";
const def = {
    bindings: {
        content: "<"
    },
    controller: HelpItemAlertsComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
